// extracted by mini-css-extract-plugin
export default {"root":"HomeworkLayout_root__DI6xS","wrapper":"HomeworkLayout_wrapper__+fJBh","left":"HomeworkLayout_left__6I-we","main":"HomeworkLayout_main__54oc9"};